module.exports = __webpack_public_path__ + "img/happytable_bg.f09308e9.jpg";